<div class="camera-box" [class.mt-4]="margemSuperior" [class.camera-box-registro]="modo === 'registro'">
  <div class="camera-stage">
    <div class="camera-zoom-layer" [style.transform]="transformacaoZoom">
      <video id="cameraVideo" class="camera-video" autoplay playsinline muted></video>
      <div
        *ngIf="caixaFace"
        class="face-detection-box"
        [class.face-detection-box-ok]="rostoDetectado"
        [style.left.%]="caixaFace.esquerda"
        [style.top.%]="caixaFace.topo"
        [style.width.%]="caixaFace.largura"
        [style.height.%]="caixaFace.altura">
      </div>
    </div>
    <div class="face-guide-label">{{ rostoDetectado ? 'Rosto detectado' : 'Posicione o rosto na camera' }}</div>
  </div>
  <canvas id="cameraCanvas" class="d-none"></canvas>
  <div class="face-status mt-2" [class.face-status-ok]="rostoDetectado">
    {{ mensagem }}
  </div>
  <div class="d-flex gap-2 mt-3">
    <button
      *ngIf="exibirConfirmar"
      type="button"
      class="btn btn-success flex-fill"
      [disabled]="capturando || !rostoDetectado || !provaVidaOk"
      (click)="confirmar.emit()">
      {{ textoConfirmar }}
    </button>
    <button
      *ngIf="exibirCancelar"
      type="button"
      class="btn btn-outline-secondary"
      [disabled]="capturando"
      (click)="cancelar.emit()">
      Cancelar
    </button>
  </div>
</div>
